import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-overview',
    templateUrl: './dialog-overview.component.html',
    styleUrls: ['./dialog-overview.component.scss'],
    standalone: false
})
export class DialogOverviewComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { type: 'error' | 'success'; message?: string; yes?: 'Yes'; no?: string }
  ) { }

  close(data?: any): void {
    this.dialogRef.close(data);
  }

}
